// Login.js
import { useState } from 'react';
import './LoginForm.css'; // 👈 importa el archivo CSS que definiste

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      if (!res.ok) {
        throw new Error('Credenciales incorrectas');
      }
      const data = await res.json();
      const token = data.token;
      localStorage.setItem('token', token);
      onLoginSuccess(token);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container"> {/* 👈 envolvemos todo en el contenedor */}
      
      <h2 className="login-title">Iniciar Sesión</h2> {/* 👈 título estilizado */}

      <form className="login-form" onSubmit={handleSubmit}> {/* 👈 form con clase */}
        <input
          type="email"
          placeholder="Email" /* 👈 en vez de label usamos placeholder */
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />

        <div className="password-wrapper"> {/* 👈 wrapper para el estilo del input password */}
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {/* si luego quieres el toggle con FontAwesome, aquí va el ícono */}
        </div>

        <button type="submit">Ingresar</button> {/* 👈 botón estilizado */}
      </form>

      {/* 👇 mensaje de error */}
      {error && <p className="login-message">{error}</p>}
    </div>
  );
}

export default Login; // 👈 export del componente
